"use client";

import { getDataAutomationId } from "@/helpers";
import { Children, createContext, ReactNode } from "react";
import { FC } from "react";
import { AutoScrollCarousel } from "@/components/AutoScrollCarousel";
import { Slider } from "@/components/Slider/Slider";

export const SliderBlockModeContext = createContext({
  autoScrollCarousel: false,
});

type SliderBlockProps = {
  autoplay?: boolean;
  autoplaySpeed?: number;
  infinite?: boolean;
  initialSlide?: number;
  speed?: number;
  vertical?: boolean;
  adaptiveHeight?: boolean;
  autoScrollCarousel?: boolean;
  hasHeader?: boolean;
  children: ReactNode;
};
export const SliderBlock: FC<SliderBlockProps> = ({
  children,
  autoScrollCarousel = false,
  hasHeader = false,
  ...sliderConfig
}) => {
  const childItems = Children.toArray(children);
  const isAutoScrollEnabled = autoScrollCarousel && childItems.length > 1;

  let content: ReactNode;

  if (!isAutoScrollEnabled) {
    content = <Slider {...sliderConfig}>{children}</Slider>;
  } else {
    const [firstChild, ...rest] = childItems;
    const headerContent = hasHeader ? firstChild : undefined;
    const cards = hasHeader ? rest : childItems;

    content = (
      <AutoScrollCarousel
        headerContent={headerContent}
        viewportClassName="overflow-x-hidden overflow-y-visible bg-transparent pt-12 pb-16 before:hidden after:hidden md:before:block md:after:block md:before:pointer-events-none md:after:pointer-events-none md:before:absolute md:after:absolute md:before:inset-y-0 md:after:inset-y-0 md:before:left-0 md:after:right-0 md:before:z-10 md:after:z-10 md:before:w-[100px] md:after:w-[100px] md:before:content-[''] md:after:content-[''] md:before:bg-[linear-gradient(270deg,rgba(255,255,255,0)_0%,#FFF_101.24%)] md:after:bg-[linear-gradient(90deg,rgba(255,255,255,0)_0%,#FFF_101.24%)]"
      >
        {cards.map((card, index) => (
          <div
            {...getDataAutomationId(`carousel-item${index}`)}
            key={`carousel-item${index}`}
            className="flex h-full self-stretch rounded-2xl shadow-[0_16px_40px_0_rgba(20,30,45,0.28)]"
          >
            {card}
          </div>
        ))}
      </AutoScrollCarousel>
    );
  }

  return (
    <SliderBlockModeContext.Provider
      value={{ autoScrollCarousel: isAutoScrollEnabled }}
    >
      {content}
    </SliderBlockModeContext.Provider>
  );
};
